import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthStore } from '@falcon/app/core/storage/auth/auth.store';
import { UserRolesEnum } from '@falcon/app/shared/models/user.model';

/** Self-onboarding admin validation (BCJ-20022) is limited to the two admin roles. */
export const REGISTRATIONS_ACCESS_ROLES = [UserRolesEnum.FULL_ADMIN, UserRolesEnum.SUPER_ADMIN];

export const registrationsAccessGuard: CanMatchFn = () => {
  const authStore = inject(AuthStore);

  return authStore.getUserData$().pipe(map(() => authStore.hasRoles(REGISTRATIONS_ACCESS_ROLES)));
};
